import { DownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { ButtonProps } from "antd/lib";
import { t } from "i18next";
import { useContext } from "react";
import { ModalsContext } from "../../../../context/modals.context";
import {
  useDownloadRequestProductionCodes,
  useDownloadRequestProformaInvoice,
} from "../../../../modules/productionCode/productionCode.queries";
import { toastService } from "../../../../utils/toast.service";
import style from "./DownloadProductionCodeRequestFile.module.scss";

interface DownloadProductionCodeRequestFileButtonProps {
  type: "proformaInvoice" | "codes";
  id: number;
  buttonProps?: ButtonProps;
  docName: string | null;
  sifraRobneMarke: string | null;
}

const DownloadProductionCodeRequestFileButton = ({
  type,
  id,
  buttonProps,
  docName,
  sifraRobneMarke,
}: DownloadProductionCodeRequestFileButtonProps) => {
  const { setError } = useContext(ModalsContext);

  const {
    mutate: downloadRequestProductionCodes,
    isPending: isDownloadingCodes,
  } = useDownloadRequestProductionCodes({
    onError: onDownloadErrorHandler,
    onSuccess: onDownloadSuccessHandler,
  });

  const {
    mutate: downloadRequestProformaInvoice,
    isPending: isDownloadingProformaInvoice,
  } = useDownloadRequestProformaInvoice({
    onError: onDownloadErrorHandler,
    onSuccess: onDownloadSuccessHandler,
  });

  function onDownloadSuccessHandler() {
    toastService.success("TOAST.DOWNLOAD_SUCCESS");
  }

  function onDownloadErrorHandler(error: Error | string) {
    setError(
      typeof error === "string" ? error : t("COMMON.DOSLO_JE_DO_GRESKE")
    );
  }

  const downloadHandler = () => {
    if (type === "codes") {
      downloadRequestProductionCodes({
        zahtevId: id,
        docName,
        sifraRobneMarke,
      });
    }
    if (type === "proformaInvoice") {
      downloadRequestProformaInvoice({
        zahtevId: id,
        docName,
        sifraRobneMarke,
      });
    }
  };

  return (
    <Button
      className={style.fontSize}
      icon={<DownloadOutlined />}
      loading={isDownloadingCodes || isDownloadingProformaInvoice}
      onClick={(event) => {
        event.stopPropagation();
        downloadHandler();
      }}
      {...buttonProps}
    >
      {type === "codes"
        ? t("TOAST.PREUZMI_KODOVE")
        : t("COMMON.PREUZMI_PREDRACUN")}
    </Button>
  );
};

export default DownloadProductionCodeRequestFileButton;
